import { Component, OnInit } from '@angular/core';
import { FolderService } from '../folder.service'
import { Title }  from '@angular/platform-browser'

@Component({
	selector: 'app-folder-dashboard',
	templateUrl: './folder-dashboard.component.html',
	styleUrls: ['./folder-dashboard.component.scss']
})
export class FolderDashboardComponent implements OnInit {

	folders: any
	demo: boolean = true

	constructor(
		public fs: FolderService,
		private titleService: Title,
	) { }

	ngOnInit() {
		this.titleService.setTitle('Attaboy | Dashboard')
		this.fs.getAccessibleFolders().subscribe(folders => {
			this.demo = !(<Array<any>>folders).map(a => a.id)['demo']
			this.folders = folders
		})
	}

}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-dashboard/folder-dashboard.component.ts